<template>
<section class="about-section">
  <div class="text-container">
    <h4 class="welcome-text">Välkommen till</h4>
    <h1 class="main-title">The Lounge Bar</h1>
    <p class="description">
      Mitt i stadens puls är The Lounge Bar platsen där du kan varva ner, umgås och njuta. Oavsett om du vill ta en avslappnad afterwork, fira något speciellt eller bara unna dig en skön kväll, är vi här för att ge dig en upplevelse utöver det vanliga.
      <br /><br />
      Vår meny är skapad med kärlek och passion, fylld med smaker som passar alla tillfällen. Kombinera detta med våra signaturcocktails och du har allt du behöver för en oförglömlig kväll.
      <br /><br />
      Här handlar det om att känna sig hemma – en plats där musiken är rätt, servicen är varm och atmosfären får dig att vilja stanna lite längre. Så varför vänta? Kom förbi, slå dig ner och låt oss ta hand om resten. Vi ser fram emot att välkomna dig till The Lounge Bar!
    </p>
  </div>
</section>

</template>


<style>

  .about-section {
  background: #1C2A1F; /* Svart gradient */
  color: #f5f5f5; /* Ljus text */
  text-align: center;
  padding: 4rem 1rem;
}


.text-container {
  max-width: 800px;
  margin: 0 auto;
}

.welcome-text {
  font-size: 1.2rem; /* Mindre textstorlek för "Välkommen till" */
  font-weight: 400; /* Normal vikt */
  color: #f5f5f5; /* Ljusare färg */
  margin: 0;
}

.main-title {
  font-size: 3rem; /* Större rubrikstorlek för "The Lounge Bar" */
  color: #937d51; /* Guldaktig färg för premiumkänsla */
  margin: 0.5rem 0 1rem; /* Litet mellanrum ovan och nedan */
}

.description {
  font-size: 1rem; /* Standardstorlek för beskrivningstexten */
  font-weight: 300; /* Tunnare text för mjuk känsla */
  line-height: 1.8; /* Bättre läsbarhet */
  color: #f5f5f5; /* Ljus text */
  margin: 0;
}
</style>